import { OutlinedInput } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import React from "react";

import styled from "styled-components";
import {
  isSingleSleeperSelector,
  primarySleeperHeightSelector,
  primarySleeperHeightFeetSelector,
  primarySleeperHeightInchesSelector,
  primarySleeperWeightSelector,
  secondarySleeperHeightSelector,
  secondarySleeperHeightFeetSelector,
  secondarySleeperHeightInchesSelector,
  secondarySleeperWeightSelector,
  setPrimarySleeperHeight,
  setPrimarySleeperHeightFeet,
  setPrimarySleeperHeightInches,
  setPrimarySleeperWeight,
  setSecondarySleeperHeight,
  setSecondarySleeperHeightFeet,
  setSecondarySleeperHeightInches,
  setSecondarySleeperWeight,
} from "../../redux/slices/mattressConfiguration";
import {checkErrorsSelector} from "../../redux/slices/customNavigation";

const StyledInput = styled.input`
  width: 80%;
  border-color: transparent;
  background-color: #f7fcfe;
  border-radius: 10px;
  font-size: 1.2rem;
  font-weight: bold;
  font-family: noto-sans;
`;

const ImperialInput = ({ onChange, unit, label, placeholder, editingSleeper1 }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const primarySleeperHeight = useSelector(primarySleeperHeightSelector);
  const primarySleeperHeightFeet = useSelector(primarySleeperHeightFeetSelector);
  const primarySleeperHeightInches = useSelector(primarySleeperHeightInchesSelector);
  const primarySleeperWeight = useSelector(primarySleeperWeightSelector);
  const secondarySleeperHeight = useSelector(secondarySleeperHeightSelector);
  const secondarySleeperHeightFeet = useSelector(secondarySleeperHeightFeetSelector);
  const secondarySleeperHeightInches = useSelector(secondarySleeperHeightInchesSelector);
  const secondarySleeperWeight = useSelector(secondarySleeperWeightSelector);
  const checkErrors = useSelector(checkErrorsSelector);

  const heightValue =
    isSingleSleeper || editingSleeper1
      ? (placeholder === "feet")
        ? primarySleeperHeightFeet + "'"
        : primarySleeperHeightInches + "\""
      : (placeholder === "feet")
        ? secondarySleeperHeightFeet + "'"
        : secondarySleeperHeightInches + "\"";

  const weightValue =
    isSingleSleeper || editingSleeper1
      ? primarySleeperWeight
      : secondarySleeperWeight;

  const trimHeight = inputValue => {
    let value = inputValue;
    value = value.replace(/'/g, "");
    value = value.replace(/"/g, "");
    value = value.trim();
    return value;
  };

  const handleOnChangeHeightFeet = event => {
    let value = trimHeight(event.target.value);
    if (editingSleeper1 || isSingleSleeper) {
      const textHeight = value + "' " + primarySleeperHeightInches + "\"";
      dispatch(setPrimarySleeperHeightFeet(value));
      dispatch(setPrimarySleeperHeight(textHeight));
    } else {
      const textHeight = value + "' " + secondarySleeperHeightInches + "\"";
      dispatch(setSecondarySleeperHeightFeet(value));
      dispatch(setSecondarySleeperHeight(textHeight));
    }
  };
  const handleOnChangeHeightInches = event => {
    let value = trimHeight(event.target.value);
    if (editingSleeper1 || isSingleSleeper) {
      const textHeight = primarySleeperHeightFeet + "' " + value + "\"";
      dispatch(setPrimarySleeperHeightInches(value));
      dispatch(setPrimarySleeperHeight(textHeight));
    } else {
      const textHeight = secondarySleeperHeightFeet + "' " + value + "\"";
      dispatch(setSecondarySleeperHeightInches(value));
      dispatch(setSecondarySleeperHeight(textHeight));
    }
  };
  const handleOnChangeHeight = event => {
    if (editingSleeper1 || isSingleSleeper) {
      dispatch(setPrimarySleeperHeight(event.target.value));
    } else {
      dispatch(setSecondarySleeperHeight(event.target.value));
    }
  };
  const handleOnChangeWeight = event => {
    if (editingSleeper1 || isSingleSleeper) {
      dispatch(setPrimarySleeperWeight(event.target.value));
    } else {
      dispatch(setSecondarySleeperWeight(event.target.value));
    }
  };

  const handleErrorCheck = event => {
    if (checkErrors) {
      return unit === "height"
        ? !trimHeight(heightValue)
        : !weightValue;
    } else {
      return false;
    }
  };

  return (
    <OutlinedInput
      className={
        unit === "height"
          ? (placeholder === "feet")
            ? "imperial-height-feet"
            : "imperial-height-inches"
          : "imperial-weight"
      }
      value={unit === "height" ? heightValue : weightValue}
      size="small"
      variant="outlined"
      label={label}
      error={handleErrorCheck(event)}
      onChange={
        unit === "height"
          ? (placeholder === "feet")
            ? event => handleOnChangeHeightFeet(event)
            : event => handleOnChangeHeightInches(event)
          : event => handleOnChangeWeight(event)
      }
      placeholder={placeholder}
      inputProps={{
        style: { fontWeight: "bold", color: theme.COLORS.BLUE.darkBlueGreen2 },
      }}
      sx={{
        marginTop: "0.5rem",
        borderRadius: "10px",
        fontWeight: "bold",
        backgroundColor: "#f7fcfe",
        width: "50% !important",
        height: "100% !important",
        fontSize: "0.85rem"
      }}
    />
  );
};

export default ImperialInput;
